import React, { ReactNode } from "react";

import "./CustomProgressBar.scss";

interface CustomProgressBarProps {
  value: number;
  max?: number;
  bgColor?: string;
  progressBarColor?: string;
  height?: number;
  labelPlacement?: "right" | "left" | "center";
  children?: ReactNode;
}

function CustomProgressBar({
  value,
  children,
  max = 100,
  bgColor = "#ffffff",
  progressBarColor = "#6C53E8",
  height = 18,
  labelPlacement = "center",
}: CustomProgressBarProps) {
  const progressBarPercentage = (value / max) * 100;

  return (
    <div
      className="custom-progress-container "
      style={{
        height,
        backgroundColor: bgColor,
      }}
    >
      <div
        className="progress-bar"
        style={{
          width: `${progressBarPercentage}%`,
          backgroundColor: progressBarColor,
        }}
      />
      <div
        className="progress-label"
        style={{ justifyContent: labelPlacement }}
      >
        <div>{children}</div>
      </div>
    </div>
  );
}

export default CustomProgressBar;
